// Figma `ic:sharp-add-home-work` on its 44px disc, add-property frame (export 15.10). Paths are the
// export's own, shifted by the translate rather than re-authored.
export default function AddPropertyIcon({ className = '' }) {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" aria-hidden="true" className={className}>
      <circle cx="22" cy="22" r="22" fill="#F8FEF4" />
      <circle cx="22" cy="22" r="21.5" stroke="#4CBC18" />
      <g transform="translate(-1446 -1021)">
        <path d="M1471 1042.68V1042L1464 1037L1457 1042V1052H1462V1046H1466V1052H1467.68C1467.25 1051.09 1467 1050.08 1467 1049C1467 1046.21 1468.64 1043.81 1471 1042.68ZM1479 1044.11V1034H1466V1035.97L1473 1040.97V1042.08C1473.33 1042.03 1473.66 1042 1474 1042C1475.96 1042 1477.73 1042.81 1479 1044.11ZM1473 1038H1475V1040H1473V1038Z" fill="#4F5F4A" />
        <path d="M1479 1049C1479 1046.24 1476.76 1044 1474 1044C1471.24 1044 1469 1046.24 1469 1049C1469 1051.76 1471.24 1054 1474 1054C1476.76 1054 1479 1051.76 1479 1049ZM1473.5 1052V1049.5H1471V1048.5H1473.5V1046H1474.5V1048.5H1477V1049.5H1474.5V1052H1473.5Z" fill="#4CBC18" />
      </g>
    </svg>
  );
}
